import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { WebAngularSharedDataAccessFeatureFlagApisService } from '../services/feature-flags.service';

export function enableDisableView(
  enableView: boolean,
  viewContainer: ViewContainerRef,
  templateRef: TemplateRef<any>,
  currentViewState: boolean
): boolean {
  // If flag is only boolean type support this
  if (typeof enableView === 'boolean')
  {  
    if (enableView && !currentViewState) {
      viewContainer.createEmbeddedView(templateRef);
      return true;
    } else if (!enableView && currentViewState) {
      viewContainer.clear();
      return false;
    }
  }
  return currentViewState;
}

@Directive({
  selector: '[appIfFeatureFlagEnabled]'
})
export class IfFeatureFlagEnabledDirective {
  private currentViewState = false;
  private flagValue: boolean;

  @Input()
  set appIfFeatureFlagEnabled(flagName: string) {
    this.flagValue = this.featureFlagsService.getFlag(flagName);
    const enableView = !!this.flagValue;

    this.currentViewState = enableDisableView(
      enableView,
      this.viewContainer,
      this.templateRef,
      this.currentViewState
    );
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureFlagsService: WebAngularSharedDataAccessFeatureFlagApisService
  ) {}
}
